/**
 * file : AllTournament/Tap/Board.jsx
 * 설명 : 게시판
 */

import $ from 'jquery';
import { Link } from 'react-router-dom';
import { Fnc, Url } from "common/globals";
import React, { useEffect, useState } from "react";
import { Search } from "components/Common/ApiCall";

export default function Board() {
  // 데이터
  const [datas, setDatas] = useState();
  // 리스트 갯수
  const [listCount, setListCount] = useState(5)
  const showMore = () => {
    let count = listCount > datas.length ? datas.length : listCount + 5
    setListCount(count);
  }
  // Toggle 관련
  const toggle = (target) => {
    $(".view").not(target).removeClass("open").next(".fold").removeClass("open");
    $(target).toggleClass("open").next(".fold").toggleClass("open")
  }
  // 조회
  useEffect(() => {
    Search('/board', setDatas, null, { type: 'P' })
  }, [])

  return (
    <div className="zeus-tab-item">
      <table className="fold-table table_style1 news">
        <thead>
          <tr>
            <th>NO</th>
            <th>제목</th>
            <th>날짜</th>
            <th>작성자</th>
          </tr>
        </thead>
        <tbody>
          {
            !Fnc.Empty(datas) && datas.slice(0, listCount).map((data, index) => (
              <React.Fragment key={index}>
                <tr className="view" onClick={(e) => {toggle(e.currentTarget);}}>
                  <td className="nu">{index +1}</td>
                  <td className="subject">{data.title}</td>
                  <td>{Fnc.FormatDate(data.created_at)}</td>
                  <td>{data.author_name}</td>
                </tr>
                <tr className="fold">
                  <td colSpan="4"> 
                    <div className="fold-content">{data.contents}</div>
                    {
                      !Fnc.Empty(data.file) && data.file.map((f) => (
                        !Fnc.Empty(f) && (<img src={`${Url.BoardImgUrl}/${f.uuid}.${f.filetype}`} alt={f.uuid} key={f.uuid} className='content-img'/>)
                      ))
                    }
                  </td>
                </tr>
              </React.Fragment>
            ))
          }
        </tbody>
      </table>
      {
        !Fnc.Empty(datas) &&
        listCount < datas.length && (
          <div className="btns_wrap mt_30 mb_30">
            <Link className="btn_more" onClick={showMore}>더불러오기</Link>
          </div>
        )
      }
    </div>
  )
}